// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"562":"589a884a","607":"cbb414d1","665":"4f507512","879":"f2a91e5e"}[chunkId] + ".chunk.js";
};